import { useRef } from 'react'
import { useField } from 'formik'
import { Stack, TimeField } from '@machobear/design-system'
import useFocusOnError from '@/hooks/use-focus-on-error'

export const FieldTimeInput = props => {
  const fieldRef = useRef()
  const [field, meta] = useField(props.name)

  useFocusOnError({ fieldRef, name: props.name })

  return (
    <Stack space="xsmall">
      <TimeField
        id={props.name}
        onAction={props.onAction}
        {...field}
        {...props}
        message={meta.error}
        tone={meta.error ? 'critical' : undefined}
      />
    </Stack>
  )
}
